import React from 'react';
import {
    IconButton,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from '@mui/material';
import * as icons from 'mdi-material-ui';

export const CommonTable = ({ tableHeaders, children, addRow }) => (
    <TableContainer sx={{ mb: 4 }}>
        <Table aria-label="caption table">
            <TableHead>
                <TableRow>
                    <TableCell sx={{ border: 'none' }}>
                        <IconButton color="primary" size="small" onClick={addRow}>
                            <icons.PlusCircle />
                        </IconButton>
                    </TableCell>
                    {tableHeaders.map(th => (
                        <TableCell
                            key={th}
                            align="center"
                            sx={{ fontSize: 16, border: '1px solid #ccc' }}
                        >
                            {th}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody sx={{ height: '100%' }}>{children}</TableBody>
        </Table>
    </TableContainer>
);
